import { memo } from 'react';

import classnames from 'classnames';

import useStyles from './styles';

import type { ToastType, ToastAction } from '@/hooks/useToast';

import { SuccessIcon, ErrorIcon, InfoIcon } from '@/components/icons';

interface ToastProps {
  message: string;
  type?: ToastType;
  action?: ToastAction;
  onActionClick?: () => void;
}

const ToastComponent = ({
  message,
  type = 'success',
  action,
  onActionClick,
}: ToastProps) => {
  const classes = useStyles();

  const Icon =
    type === 'error' ? ErrorIcon : type === 'info' ? InfoIcon : SuccessIcon;

  const handleActionClick = () => {
    action?.onClick();
    onActionClick?.();
  };

  return (
    <div className={classnames(classes.toast, classes[type])}>
      <div className={classes.content}>
        <Icon />
        {message}
      </div>
      {action && (
        <button
          type="button"
          className={classes.actionButton}
          onClick={handleActionClick}
        >
          {action.label}
        </button>
      )}
    </div>
  );
};

export const Toast = memo(ToastComponent);
export default Toast;
